const BASIC_PROD_URL = 'https://boka.uthyrd.se';
const BASIC_DEV_URL = 'http://localhost:3000';

export default {
    BASIC_PROD_URL,
    BASIC_DEV_URL
}
